/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LawyerType {
  Barrister = "Barrister",
  Solicitor = "Solicitor",
}

export const LawyerTypeDisplay: Record<LawyerType, string> = {
  [LawyerType.Barrister]: "Barrister",
  [LawyerType.Solicitor]: "Solicitor",
};
